import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ProductService } from '@app/services/product.service';
declare var $: any;

@Component({
  selector: 'app-products-create',
  templateUrl: './products-create.component.html',
  styleUrls: ['./products-create.component.scss']
})
export class ProductsCreateComponent implements OnInit, OnDestroy {
  public DEFAULT_IMAGE = '/assets/images/default_product.png';
  public product;
  public id;
  public env = environment;
  public validation = {
    image: true,
    name: true,
    salesPrice: true,
    netCosts: true
  };

  constructor(public route: ActivatedRoute, public productService: ProductService, public location: Location, public router: Router) {}

  ngOnInit() {
    this.reset();
  }

  ngOnDestroy() {
    this.reset();
  }

  reset() {
    this.product = {
      toppings: []
    };

    this.validation = {
      image: true,
      name: true,
      salesPrice: true,
      netCosts: true
    };

    $('.modal .image-container').css('background-image', 'url(' + this.DEFAULT_IMAGE + ')');
  }

  showImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (event2: any) => {
        this.product.image = event2.target.result;
        $('.modal .image-container').css('background-image', 'url(' + this.product.image + ')');
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  save() {
    this.validation.image = this.product.image !== this.DEFAULT_IMAGE;
    this.validation.name = !!this.product.name;
    this.validation.salesPrice = !!this.product.salesPrice;
    this.validation.netCosts = !!this.product.netCosts;

    if (this.validation.image && this.validation.name && this.validation.salesPrice && this.validation.netCosts) {
      this.productService.create(this.product).subscribe(() => this.router.navigate(['products']));
    }
  }

  addTopping(topping) {
    for (let i = 0; i < this.product.toppings.length; i++) {
      if (this.product.toppings[i]._id === topping._id) {
        return;
      }
    }

    this.product.toppings.push(topping);
  }

  removeTopping(topping) {
    for (let i = 0; i < this.product.toppings.length; i++) {
      if (this.product.toppings[i]._id === topping._id) {
        this.product.toppings.splice(i, 1);
        return;
      }
    }
  }
}
